import { createAction, createReducer } from 'redux-act';
import { LOCATION_CHANGE } from 'react-router-redux';

import * as R from 'ramda';

const initialState = {};

export const setNotify = createAction('NOTIFY__SET_NOTIFY');

const handleSetNotify = (state, payload) => {
  const types = ['isBalanceda'];

  return R.reduce((acc, status) => {
    const action = payload[status];

    if (action !== undefined) {
      const lens = R.lensProp(status);
      return R.set(lens, action, acc);
    }
    return acc;
  }, state, types);
};

const handleLocationChange = state =>
  handleSetNotify(state, {
    isBalanceda: false,
  });

const reducer = createReducer((on) => {
  on(setNotify, handleSetNotify);
  on(LOCATION_CHANGE, handleLocationChange);
}, initialState);

export default reducer;